import React, { useState } from 'react';
import { ArrowLeft, Plus, Key } from 'lucide-react';
import { Button } from './ui/button';
import ChangePasswordModal from './ChangePasswordModal';

/**
 * Reusable admin panel header with navigation, title, and common actions
 */
const AdminHeader = ({ 
  title, 
  onBackToHome, 
  onLogout,
  onAddNew,
  addNewLabel = 'Add New',
  showAddButton = true 
}) => {
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <>
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={onBackToHome}
                className="inline-flex items-center text-gray-600 hover:text-blue-600 transition-colors"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </button>
              <h1 className="text-xl font-bold text-gray-900">{title}</h1>
            </div>
            <div className="flex items-center gap-3">
              {showAddButton && onAddNew && (
                <Button
                  onClick={onAddNew}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  {addNewLabel}
                </Button>
              )}
              <Button
                variant="outline"
                onClick={() => setShowChangePassword(true)}
                className="text-gray-600"
                title="Change Password"
              >
                <Key className="w-4 h-4" />
              </Button>
              <Button
                variant="outline"
                onClick={onLogout}
                className="text-gray-600"
              >
                Logout
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ChangePasswordModal
        isOpen={showChangePassword}
        onClose={() => setShowChangePassword(false)}
      />
    </>
  );
};

export default AdminHeader;
